export default "__VITE_ASSET__wOK1Z9lk__"